import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { errorHandler } from '@/shared/lib/errorHandler'
import { EditPromotionFormState } from '../model/types'
import { UploadPromotionPhoto } from '@/entities/Photos/api/photo-promotion'
import {
  currentPromotionByIdQueryKey,
  promotionListsByPageQueryKey,
} from '@/entities/Promotions/api/promotions-api'
import { Promotion, topliApi } from '@/shared/api/topli/TopliApi'
import { formatDateForSending } from '@/shared/lib/utils'

export const editPromotion = async (state: EditPromotionFormState) => {
  const { id, start_date, end_date, is_permanent, residential_projects, thumbnail, ...restState } =
    state

  const body = {
    start_date: formatDateForSending(start_date) as string,
    end_date: is_permanent ? null : formatDateForSending(end_date),
    is_permanent,
    residential_projects: residential_projects?.map(item => Number(item)),
    ...(typeof thumbnail === 'string' && thumbnail ? { thumbnail } : {}),
    ...restState,
  }

  const response = await topliApi.promotions.update(id, body)
  return response
}

export const useEditPromotionApi = (): UseMutationResult<
  Promotion,
  Error,
  EditPromotionFormState
> => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: state => editPromotion(state),
    onSuccess: async (res, state) => {
      try {
        if (state.thumbnail && typeof state.thumbnail === 'object') {
          await UploadPromotionPhoto({
            file: state.thumbnail,
            id: res.id,
          })
        }

        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: [promotionListsByPageQueryKey],
            refetchType: 'active',
          }),
          queryClient.invalidateQueries({
            queryKey: [currentPromotionByIdQueryKey],
            refetchType: 'active',
          }),
        ])
      } catch (error) {
        errorHandler(error)
      }
    },
  })
}
